import React, { useState, useEffect } from 'react'
import {  Container, Row, Col, Image, Carousel } from 'react-bootstrap'
import config from './constants/config'
import { Grid, Box } from '@mui/material'
import './style/App.css'
import appStoreIconImg from './assets/images/app_store_icon.jpg'
import playStoreIconImg from './assets/images/play_store_icon.jpg'
import appStoreIconPng from './assets/images/app_store_icon.png'
import playStoreIconPng from './assets/images/play_store_icon.png'
import justinNImg from './assets/images/justin_n.jpg'
import najeeBImg from './assets/images/najee_b.jpg'
import anthonyPImg from './assets/images/anthony_p.jpg'
import homepageCalendarImg from './assets/images/homepage_calendar.png'
import homepageCashImg from './assets/images/homepage_cash.png'
import homepageToolsImg from './assets/images/homepage_tools.png'
import phoneImg from './assets/images/phone.jpg'
import jacobParisImg from './assets/images/jacob_paris.jpg'
import joseImg from './assets/images/jose.jpg'
import justinNealImg from './assets/images/justin_neal.jpg'
import jerryImg from './assets/images/jerry.jpg'

const images = {
  app_store_icon: appStoreIconImg,
  play_store_icon: playStoreIconImg,
  app_store_icon_png: appStoreIconPng,
  play_store_icon_png: playStoreIconPng,
  justin_n: justinNImg,
  najee_b: najeeBImg,
  anthony_p: anthonyPImg,
  homepage_calendar: homepageCalendarImg,
  homepage_cash: homepageCashImg,
  homepage_tools: homepageToolsImg,
  phone: phoneImg,
  jacob_paris: jacobParisImg,
  jose: joseImg,
  justin_neal: justinNealImg,
  jerry: jerryImg
}

const testimonials = () => {
  return (
    <div id="testimonials_section" className="home_page_section" style={{ backgroundColor: "#5166A6", color: "#D7D7D9" }}>
    <Row> <Col md={12}><h2 className="text-center">Testimonials</h2></Col></Row>
    <Row>
      <Col className="d-flexx flex-row justify-content-center align-items-center" md={12}>
        <Carousel>
        <Carousel.Item>
            <div
              className="testimonial_sectionx">
              <img
                className="testimonial_image"
                src={images.justin_neal}
                alt="Justin N." />
            </div>
            <Carousel.Caption>
              <h4>Justin N.</h4>
              <p>With {config.name2}, I focus more on running my business than dealing with administrative and organizational tasks.
                <strong> It saves me both time and money.</strong>
              </p>
              <p style={{fontStyle: 'italic'}}>Moving Company Owner - Houston, TX</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="testimonial_image"
              src={images.najee_b}

              alt="Najee B."
            />
            <Carousel.Caption>
              <h3>Najee B.</h3>
              <p>{config.name2} gets me the jobs that I want to work when I want to work them.
                <strong> I highly recommend it to those looking to make money on their own terms.</strong>
              </p>
              <p style={{fontStyle: 'italic'}}>Mover - Los Angeles, CA</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="testimonial_image"
              src={images.jerry}
              alt="Jerry G." />
            <Carousel.Caption>
              <h3>Jerry G.</h3>
              <p>With {config.name2}, it was super easy to schedule and communicate with the moving company. 
              <strong> I wish ALL moving companies used this app.</strong>
            </p>
            <p style={{fontStyle: 'italic'}}>Residential Shipper - Denver, CO</p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </Col>
    </Row>
    </div>
  )
}

function installApp() {
  return (
    <div className="home_page_section centerX" >
      <Row> <Col md={12}><h2 className="text-center">Install {config.name2}</h2></Col></Row>

      <a target="_blank" href="https://apps.apple.com/us/app/atlas-labor/id1437078036">
        <Image
          src={images.app_store_icon}
          className="app_play_store_large image_link" />
      </a>
      <a target="_blank" href="https://play.google.com/store/apps/details?id=com.atlaslabor&hl=en_US">
        <Image
          src={images.play_store_icon}
          className="app_play_store_large image_link" />
      </a>
    </div>
  );
}

const about = () : JSX.Element => {
  return (
      <Row className="home_page_section" style={{ backgroundColor: "#5166A6", color: "#D7D7D9" }}>
        <Col className="d-flexx flex-row justify-content-center align-items-center" md={6} style={{padding: '0px 50px 0px 50px'}}>
          <Image
            src={images.jacob_paris}
            width="100%" />
          <br /><br />
          <p style={{fontStyle: "italic", textAlign: 'center'}}>Great opportunity for part-time workers, gig workers, and students.</p>
        </Col>
        <Col className="d-flexx flex-row justify-content-center align-items-center" md={6} style={{padding: '0px 50px 0px 50px'}}>
            <h3>Opportunities Available</h3>
            <br />
            <p>Looking to make some extra cash while not being tied down to a schedule?  We have move jobs in your area that need your muscle!</p>
            <br />
            <p>
                &#x1F911; &nbsp;<strong>Competitive Pay</strong> - Workers on our platform are paid $18.00-$30.00/hour plus tip.<br />
                <br />
                &#x1F911; &nbsp;<strong>Work When You Want</strong> - Sign up for jobs you want to work.  No commitment required!<br />
                <br />
                &#x1F911; &nbsp;<strong>Build A Career</strong> - Enjoying the industry? We will help you level-up and get your own company started.<br />
                <br />
                &#x2705; &nbsp;<strong>Install and Register</strong> - Install our app and register.  A rep will reach out to you immediately after and get you started!
              <br /><br />
              <div style={{textAlign: 'center'}}>
                <a target="_blank" href="https://apps.apple.com/us/app/movesheet/id1437078036">
                  <Image
                    src={images.app_store_icon_png}
                    className="app_play_store_large image_link" />
                </a>
                <a target="_blank" href="https://play.google.com/store/apps/details?id=com.atlaslabor&hl=en_US">
                  <Image
                    src={images.play_store_icon_png}
                    className="app_play_store_large image_link"
                    />
                </a>
              </div>
            </p>
            
        </Col>
      </Row>
  )
}

const clients = () : JSX.Element => {
  return (
    <Row className="home_page_section">
        <Col className="d-flexx flex-row justify-content-center align-items-center" md={6} style={{padding: '0px 50px 0px 50px'}}>
            <h3>Shipping With A MoveSheet Company</h3>
            <br />
            <p>Moving soon?  Our moving company subscribers use our platform to help organize and streamline their jobs with you.</p>
            <br />
            <p>
                &#128073; &nbsp;<strong>Organize Your Move</strong> - Keep details of your move organized with us while simultaneously sharing job requirements with your movers or laborers.<br />
                <br />
                &#128073; &nbsp;<strong>Seamless Payments</strong> - Pay for your move or labor through our app.<br />
                <br />
                &#x2705; &nbsp;<strong>Install and Sign In</strong> - Install our app and sign in with the credentials created for you by the company that onboarded you.
              <br /><br />
              <div style={{textAlign: 'center'}}>
                <a target="_blank" href="https://apps.apple.com/us/app/movesheet/id1437078036">
                  <Image
                    src={images.app_store_icon}
                    className="app_play_store_large image_link" />
                </a>
                <a target="_blank" href="https://play.google.com/store/apps/details?id=com.atlaslabor&hl=en_US">
                  <Image
                    src={images.play_store_icon}
                    className="app_play_store_large image_link"
                    />
                </a>
              </div>
            </p>
        </Col>
        <Col className="d-flexx flex-row justify-content-center align-items-center" md={6} style={{padding: '0px 50px 0px 50px'}}>
          <Image
            src={images.jose}
            width="100%" />
          <br /><br />
          <p style={{fontStyle: "italic", textAlign: 'center'}}>MoveSheet subscriber Denver Labor Team posing with satisfied clients.</p>
        </Col>
      </Row>
  )
}


const FrontEnd = () => {
  return (
    <div className="App" style={{ paddingTop: 25, paddingBottom: 25 }}>

      <Row style={{ marginBottom: 25, marginLeft: 0, marginRight: 0 }}>
        <Col className="d-flex flex-row justify-content-center align-items-center" md={6}>
          <Row className="justify-content-center">
            <Col className="col-12 text-center">
              <h1>{config.name}</h1>
            </Col>
            <Col className="col-12 text-center">
              <h4 style={{}}>Organize Your Move</h4>
            </Col>
            <a target="_blank" href="https://apps.apple.com/us/app/movesheet/id1437078036">
              <Image
                src={images.app_store_icon}
                className="app_play_store_large image_link" />
            </a>
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.atlaslabor&hl=en_US">
              <Image
                src={images.play_store_icon}
                className="app_play_store_large image_link" />
            </a>
            <Col className="col-12 text-center">
              <a href="/register">Or get started with our web app</a>
            </Col>
          </Row>
        </Col>
        <Col className="text-center" md={6}>
          <Image
            // id="ss_home"
            style={{ width: "100%", height: "100%" }}
            src={phoneImg}
          />
        </Col>
      </Row>

      {about()}
      {clients()}
      {testimonials()}
      {installApp()}
    </div>
  );
}

export default FrontEnd;
